import React, { useEffect } from "react";
import "./Modal.scss";

interface ModalProps {
  open: boolean;
  title?: string;
  width?: string;
  onClose?: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  /** 오버레이(외부) 클릭으로 닫기 허용 여부. 기본 true */
  closeOnOverlayClick?: boolean;
}

const Modal: React.FC<ModalProps> = ({ open, title, width = "520px", onClose, children, footer, closeOnOverlayClick = true }) => {
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={closeOnOverlayClick ? onClose : undefined}>
      <div className="modal" style={{ width }} onClick={(e) => e.stopPropagation()}>
        {title && (
          <div className="modal__header">
            <h3 className="modal__title">{title}</h3>
            {onClose && (
              <button className="modal__close" onClick={onClose}>
                ✕
              </button>
            )}
          </div>
        )}
        <div className="modal__body">{children}</div>
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
